<template>
  <div
    class="m-pc-guest-info top-nav"
    id="meetingGuest"
    v-if="extras.meetingGuest.display == 1"
  >
    <Title
      v-if="extras.meetingGuestTitle.display == 1"
      :title="extras.meetingGuestTitle.model || title"
    />
    <div class="g-guest-desc u-w1200" id="guest">
      <div class="guest-swiper">
        <ul class="list">
          <swiper :options="swiperOptions">
            <swiper-slide
              v-for="(item, index) in tempGuests"
              :key="index"
              class="swiper-slide"
            >
              <li
                v-for="(guest, i) in item"
                :key="i"
                class="pull-left u-ml20 u-mr20"
              >
                <div class="g-info-top" style="height: 100%">
                  <img
                    :src="guest.realPath || defaultHeader"
                    :alt="guest.name"
                  />
                </div>
                <div class="g-info-bottom">
                  <div class="name u-mb8">{{ guest.name }}</div>
                  <div class="position">{{ guest.enterprise }}</div>
                  <div class="position center">{{ guest.duty }}</div>
                </div>
              </li>
            </swiper-slide>
          </swiper>
        </ul>
        <div class="swiper-button-prev" v-if="guests.length > 3"></div>
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-button-next" v-if="guests.length > 3"></div>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
      </div>

      <div class="m-nodata-body" v-if="guests.length == 0">
        <img src="@/assets/images/nodata.png" />
        <div class="m-nodata">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/index/Title.vue";

export default {
  components: {
    Title,
  },

  props: {
    guests: [],
    extras: Object,
  },
  data() {
    return {
      title: "参会嘉宾",
      defaultHeader: require("../../assets/images/pc/default.jpg"),
      swiperOptions: {
        slidesPerView: "auto",
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
        loop: false,
      },
    };
  },
  created() {
    console.log("guests", this.guests);
    // for (let i = 0, len = this.guests.length; i < len; i += 4) {
    //   let list = this.guests.slice(i, i + 4);
    //   console.log(i);
    //   console.log(i + 4);
    //   if (list.length) {
    //     this.tempGuests.push(list);
    //   }
    // }
    // console.log("array", this.tempGuests);
  },
  computed: {
    tempGuests: function () {
      console.log("guests", this.guests);
      let tempGuests = [];
      for (let i = 0, len = this.guests.length; i < len; i += 3) {
        tempGuests.push(this.guests.slice(i, i + 3));
      }
      console.log(tempGuests);
      return tempGuests;
    },
  },
};
</script>
<style lang="scss" scoped>
//.swiper-container {
//  height: 332px;
//}
</style>
